import React, { useState, useEffect, useCallback } from 'react';

import { Textarea, Input, Select, SelectMulti, Switch, InputNumberFormat, ColorPickerInputGroup } from 'twyne-new.ui';

import { useGlobalStore } from '@Stores/global';

import HTMLEditorPreview from '../HTMLEditorPreview';
import PopoverConfirmation from '../PopoverConfirmation';
import TwyneURL from '../form/TwyneURL';
import TcpaConsentDbaModal from '../tcpaConsentDba/Modal';

import GroupField from './fields/GroupField'
import HasManyField from './fields/HasManyField'
import HtmlField from './fields/HtmlField'
import ImageField from './fields/ImageField'
import TabField from './fields/TabField'
import WildcardComponent from './fields/Wildcard';

const StringComponent = (props) => {
  return <Input type="text" {...props} />
}

const LargeStringComponent = (props) => {
  return <Textarea rows={props.config.rows || 5} {...props} />
}

const NumberComponent = ({ config, ...props }) => {
  const { max, min } = config

  const isAllowed = useCallback(({ value }) => {
    if (!value || (min === undefined && max === undefined)) return true
    if ((min !== undefined && value < min) || (max !== undefined && value > max)) return false
    return true
  }, [min, max])

  return <InputNumberFormat className="form-control" isAllowed={isAllowed} {...props} />
}

const DateComponent = (props) => {
  return <Input type="date" {...props} />
}

const BooleanComponent = (props) => {
  const { name, value } = props;

  return (
    <div>
      <Switch
        id={name}
        value={value ? value : false}
        {...props}
      />
      <em />
    </div>
  )
}

const BooleanConfirmationComponent = (props) => {
  const { name, value, config, onChange } = props
  const [checked, setChecked] = useState(value ? Boolean(value) : false)

  const handleClick = () => {
    if (checked) {
      setChecked(false)
      onChange(false)
    } else {
      setChecked(true)
      onChange(true)
    }
  }

  return (
    <PopoverConfirmation
      trigger={<Switch value={checked} />}
      id={name}
      title={config.confirmation.title}
      subtitle={!checked ? config.confirmation.true_message : config.confirmation.false_message}
      yesAction={() => handleClick()}
    />
  )
}

const TagListComponent = (props) => {
  const { options, value, onChange } = props;
  return (
    <SelectMulti
      closeOnSelect={false}
      options={options}
      value={value}
      onChange={onChange}
    />
  )
}

const CustomListComponent = (props) => {
  const { options, value, onChange } = props;
  return (
    <Select
      value={value}
      onChange={onChange}
      options={options}
    />
  )
}

const CustomfieldListComponent = (props) => {
  const { customFields: { getFields } } = useGlobalStore()
  const [options, setOptions] = useState([])

  const loadOptions = useCallback(async () => {
    const customFields = await getFields()
    const options = customFields.map(({ key, name, type }) => ({
      label: `${name} (${type})`,
      value: `cf_${key}`
    }))
    setOptions(options)
  }, [getFields])

  useEffect(() => {
    loadOptions()
  }, [loadOptions])

  return <CustomListComponent {...props} options={options} />
}

const ColorPickerComponent = props => {
  const { value, onChange } = props;

  const handleChange = value => {
    onChange(value?.rgbaParsed.replace('rgba(', '').replace(')', ''))
  }

  return (
    <div>
      <ColorPickerInputGroup
        components={['picker', 'preview']}
        value={value}
        onChange={handleChange}
      />
    </div>
  )
}

export default {
  'tcpa-consent-dba': TcpaConsentDbaModal,
  string: StringComponent,
  'twyne-url': TwyneURL,
  integer: NumberComponent,
  number: NumberComponent,
  boolean: BooleanComponent,
  "boolean-confirmation": BooleanConfirmationComponent,
  html: HtmlField,
  'html-preview': HTMLEditorPreview,
  date: DateComponent,
  color: ColorPickerComponent,
  'large-string': LargeStringComponent,
  'static-list': CustomListComponent,
  'customfield-list': CustomfieldListComponent,
  'static-tag-list': TagListComponent,
  'group': GroupField,
  'tab': TabField,
  'has-many': HasManyField,
  'image': ImageField,
  'wildcard': WildcardComponent
}
